import { KEYS, NAMESPACE } from "./i18n/clientAttachment.i18n";

function localizer($app, key) {
    return $app.res({
        namespace: NAMESPACE,
        key: KEYS[key]
    });
}

// mirrors AttachmentStatusAction.Type enum in AttachmentListAJAX.cs
export const ATTACHMENT_STATUS_ACTION = {
    save: 0,
    approve: 1,
    reject: 2,
    unmark: 3
};

export const ATTACHMENT_UPDATED_EVENT = "attachmentUpdated";

// mirrored by AttachmentContentDisplayType enum in AttachmentViewModel.cs
export const ATTACHMENT_CONTENT_DISPLAY_TYPE = {
    unsupported: 0,
    pdf: 1,
    image: 2
};

// Mirror of attachment approval status in server clientAttachment
export const ATTACHMENT_APPROVAL_STATUS = {
    pending: 0,
    approved: 1,
    rejected: 2
};

export function isAttachmentInStatus(clientAttachment, status) {
    return clientAttachment.Status === status;
}

export function getApprovalStatusDisplayClass(approvalStatus, hidePending) {
    switch (approvalStatus) {
        case ATTACHMENT_APPROVAL_STATUS.pending:
            return hidePending ? "" : "text-bubble-info";
        case ATTACHMENT_APPROVAL_STATUS.approved:
            return "text-bubble-success";
        case ATTACHMENT_APPROVAL_STATUS.rejected:
            return "text-bubble-danger";
        default:
            throw "Unrecognized attachment approval status";
    }
}

export function getApprovalStatusDisplay(approvalStatus, hidePending) {
    switch (approvalStatus) {
        case ATTACHMENT_APPROVAL_STATUS.pending:
            return hidePending ? "" : "Unmarked";
        case ATTACHMENT_APPROVAL_STATUS.approved:
            return "Approved";
        case ATTACHMENT_APPROVAL_STATUS.rejected:
            return "Rejected";
        default:
            throw "Unrecognized attachment approval status";
    }
}

export const ATTACHMENT_NOTE_CHAR_LIMIT = 180;

export function getTruncatedNoteContent(note) {
    return note.substring(0, ATTACHMENT_NOTE_CHAR_LIMIT);
}

export async function confirmViewSensitiveAttachment(controller, isViewAttachment) {
    if (!controller.$app.loggedInUserHasMfa && !controller.$app.loggedInUserIsSsoInProgram) {
        // Need to close any existing dialog to ensure user can see
        // the mfa dialog
        controller.$app.closeDialog();
        if (controller.$refs.mfaRequiredDialog != null) {
            controller.$refs.mfaRequiredDialog.show();
        } else {
            controller.$emit("show-mfa-dialog");
        }

        return false;
    }

    const title = isViewAttachment
        ? localizer(controller.$app, "viewSensitiveAttachmentHeader")
        : localizer(controller.$app, "downloadSensitiveAttachmentHeader");
    const okResult = "OK";
    const cancelResult = "CANCEL";
    const dialogResult = await controller.$app.showDialog({
        title,
        message: localizer(controller.$app, "confirmRevealAttachmentMessage"),
        buttons: [
            {
                text: localizer(controller.$app, "cancelButtonText"),
                result: cancelResult
            },
            {
                text: localizer(controller.$app, "okButtonText"),
                primary: true,
                result: okResult
            }
        ]
    });
    return dialogResult === okResult;
}
